module.exports = __webpack_public_path__ + "static/fonts/Roboto700italic.9098d3de.ttf";